var extend = require('jquery-extend')

var profile =
  typeof process !== 'undefined' && process.env ? process.env.CONF : null
var conf = require('./default')

if (profile) {
  conf = extend(true, {}, conf, require('./' + profile))
}

// expose env var so that envify can pick it up
// process.env.MEINE_REISE_API = __dirname + '/../api/' + conf.api

module.exports = conf
